module.exports = __webpack_public_path__ + "static/media/SSN.876263fa.png";